import {CHAIN} from "../../constants";

/**
 * Given on the state, set the right variation on the product
 */

export default function variantConnector(store) {
    let {input, chain, necklaceLength, goldColor, necklaceOrientation} = store.getState();

    if (!/au/.test(location.hostname)) {
        console.warn('Variant connector is off in test environment');
    }

    let sku = `au-letter-necklace-${chainTypeToAbbreviation(chain)}-${necklaceLength.description.slice(0, 2)}-${input.length}`;

    if (!window.productVariants) {
        console.error(sku);
        throw new Error('Product variants hash is missing in window object');
    }

    let selectedVariant = window.productVariants.find((variant) => variant.sku === sku);

    /** Code below mimics product-options code **/

    timber.productPage({
        variant: selectedVariant
    });

    if (selectedVariant) {
        document.querySelector("[data-js='master-select']").value = selectedVariant.id;
        document.getElementById('gold-color').value = goldColor.description;
        document.getElementById('letter-orientation').value = necklaceOrientation.description;
        document.getElementById('necklace-text').value = input.toUpperCase();

        if (window.affirm) {
            window.affirm.ui.ready(function () {
                if (document.querySelector('.affirm-as-low-as')) {
                    document.querySelector('.affirm-as-low-as').setAttribute('data-amount', selectedVariant.price);
                    window.affirm.ui.refresh();
                }
            });
        }

        window.selectedVariant = selectedVariant.title;
    }
}

function chainTypeToAbbreviation(chain) {
    switch (chain) {
        case CHAIN.CABLE:
            return 'cable';
        case CHAIN.BEAD:
            return 'bead';
        case CHAIN.BUTCH:
            return 'butch';
    }
}
